import React,{useMemo} from 'react';
import {Box,Typography,Paper,Divider} from '@mui/material';
import {useLocation} from 'react-router-dom';

const useQuery=()=>new URLSearchParams(useLocation().search);
const modules=['geriatric','adolescent','camps','occupational','rmnch'];

function read(citizenId,visitId,mod){
  try{
    const k=`clinical:${mod}:${citizenId||'unspecified'}:${visitId||'none'}`;
    return JSON.parse(localStorage.getItem(k)||'null');
  }catch{return null;}
}

export default function ClinicalServicesReport(){
  const q=useQuery(); const citizenId=q.get('citizenId')||''; const visitId=q.get('visitId')||'';
  const data=useMemo(()=>Object.fromEntries(modules.map(m=>[m,read(citizenId,visitId,m)])),[citizenId,visitId]);

  return(
    <Box className="p-6">
      <Typography variant="h5" sx={{mb:2}}>Clinical Services — Consolidated Report</Typography>
      <Typography variant="body2" color="text.secondary" sx={{mb:2}}>Citizen: {citizenId || '—'} {visitId?`• Visit: ${visitId}`:''}</Typography>

      {modules.map((m)=> {
        const block=data[m]; if(!block || block.includeInReport===false) return null;
        return (
          <Paper key={m} variant="outlined" sx={{p:2, mb:2}}>
            <Typography variant="h6" sx={{mb:1, textTransform:'capitalize'}}>{m.replace('rmnch','RMNCH')}</Typography>
            <pre style={{margin:0,whiteSpace:'pre-wrap',fontFamily:'inherit'}}>{JSON.stringify(block,null,2)}</pre>
          </Paper>
        );
      })}
      <Divider sx={{my:2}}/>
      <Typography variant="caption" color="text.secondary">Tip: Print to PDF from your browser to export this panel.</Typography>
    </Box>
  );
}
